import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './../pagination_fix.sass'

import styles from './../style/KatalogRazdeli.module.scss';

import SwiperArrowLeft from '../icons/SwiperArrowLeft';
import SwiperArrowRight from '../icons/SwiperArrowRight';

class KatalogRazdeli extends React.Component {
  constructor(props) {
    super(props);
    this.swiperRef = React.createRef();
    this.nextButtonRef = React.createRef();
    this.prevButtonRef = React.createRef();
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext();
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev();
    }
  }

  render() {
    const { items } = this.props;

    // Общие настройки навигации для обоих Swiper
    const navigationSettings = {
      nextEl: this.nextButtonRef.current,
      prevEl: this.prevButtonRef.current,
    };

    return (
      <div className={styles.catalogSection}>
        <div className="d-none d-md-block">
          <Swiper
            ref={this.swiperRef}
            modules={[Navigation]}
            spaceBetween={5}
            slidesPerView={4}
            autoHeight={false}
            loop={true}
            navigation={navigationSettings}
            observer={false}
            resizeObserver={false}
            breakpoints={{
              0: {
                slidesPerView: `auto`,
                spaceBetween: 5
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 20
              }
            }}
          >
            {items.map((item, index) => (
              <SwiperSlide key={index}>
                <div 
                  key={item.id} 
                  className={styles.catalogCard}
                >
                  <a href={item.link} className={styles.cardContent} style={item.image != '' ? { backgroundImage: `url(${item.image})` } : {}}>
                    <div className={styles.cardIcon}>
                      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="33" height="33" rx="16.5" fill="#E4ECEF"/>
                        <path d="M12 21L21 12M21 12H13.8M21 12V19.2" stroke="black" strokeWidth="1.08" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <h3 className={styles.cardTitle} dangerouslySetInnerHTML={{__html: item.pagetitle}} />
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="d-md-none">
          <Swiper
            ref={this.swiperRef}
            modules={[Navigation, FreeMode, Pagination]}
            spaceBetween={5}
            slidesPerView={4}
            autoHeight={false}
            loop={true}
            pagination={{ type: `progressbar` }}
            navigation={navigationSettings}
            observer={false}
            resizeObserver={false}
            breakpoints={{
              0: {
                slidesPerView: `auto`,
                spaceBetween: 5,
                freeMode: true
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 20
              }
            }}
          >
            {items.map((item, index) => (
              <SwiperSlide className={styles.catalogCardSwiper} key={index}>
                <div 
                  key={item.id} 
                  className={styles.catalogCard}
                >
                  <a href={item.link} className={styles.cardContent} style={item.image != '' ? { backgroundImage: `url(${item.image})` } : {}}>
                    <div className={styles.cardIcon}>
                      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="33" height="33" rx="16.5" fill="#E4ECEF"/>
                        <path d="M12 21L21 12M21 12H13.8M21 12V19.2" stroke="black" strokeWidth="1.08" strokeLinecap="round"/>
                      </svg>
                    </div>
                    <h3 className={styles.cardTitle} dangerouslySetInnerHTML={{__html: item.pagetitle}} />
                  </a>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className={styles.swiperControls}>
          <div 
            ref={this.prevButtonRef}
            className={`${styles.swiperButton} ${styles.swiperButtonPrev} d-none`}
          >
            <SwiperArrowLeft />
          </div>
          <div 
            ref={this.nextButtonRef}
            className={`${styles.swiperButton} ${styles.swiperButtonNext}`}
          >
            <SwiperArrowRight />
          </div>
        </div>
      </div>
    );
  }
}

KatalogRazdeli.propTypes = {
  items: PropTypes.array
};

KatalogRazdeli.defaultProps = {
  items: []
};

export default KatalogRazdeli;